export default "__VITE_ASSET__9GlL8n04__"